module.exports = __webpack_public_path__ + "static/media/copy-code.06b900ec.webm";